// A bin tag's raw code is DT (or DR / DB) and two digits per character of the
// ID printed on it (0-9 -> 00-09, A-Z -> 11-36), then ::<client number>:
// DT32233002::0701000001 is VMT2. Screens show the printed ID; the raw code
// still searches and exports. Worker cards (DTU) and anything else keep
// their code. The API's services/item-label.js dtDisplayCode is the same.

export function dtDisplayCode(raw: string | null | undefined): string {
  if (typeof raw !== 'string' || raw.startsWith('DTU')) return ''
  const head = raw.replace(/::/g, ':').split(':')[0]
  if (!['DT', 'DR', 'DB'].includes(head.slice(0, 2))) return ''
  let out = ''
  for (let i = 2; i + 1 < head.length; i += 2) {
    const pair = head.slice(i, i + 2)
    const n = /^\d\d$/.test(pair) ? Number(pair) : -1
    if (n >= 0 && n <= 9) out += String(n)
    else if (n >= 11 && n <= 36) out += String.fromCharCode(54 + n)
  }
  return out
}

export const chipLabel = (code: string | null | undefined): string => (code && dtDisplayCode(code)) || code || ''
